import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import { shape, number, array } from "prop-types";
import Technician from "../Technician";
import { centerMyMap, getCurrentPosition } from "./utils/maps";
import locationIcon from "../../../../assets/svg/location.svg";
import equals from "ramda/src/equals";
class ProductMarker extends Component {
  render() {
    return (
      <div>
        <img
          src={locationIcon}
          alt="Product location"
          lat={this.props.lat}
          lng={this.props.lng}
        />
      </div>
    );
  }
}

class TechnicianMap extends Component {
  state = {
    center: {
      lat: -18.9128,
      lng: -48.2755,
    },
    isMapCentered: false,
  };

  componentDidMount() {
    const { techniciansLocale, clientLocale } = this.props;
    if (!clientLocale && techniciansLocale.length === 0) {
      this.getMyPosition();
    } else {
      const { isMapCentered, center } = this.state;
      if (!isMapCentered) {
        const newCenter = centerMyMap(techniciansLocale) || center;
        this.setState({ center: newCenter, isMapCentered: true });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const isNewCenter = !equals(this.state.center, nextState.center);
    const isNewClientLocale = !equals(
      this.props.clientLocale,
      nextProps.clientLocale
    );
    const isNewTechniciansLocale = !equals(
      this.props.techniciansLocale,
      nextProps.techniciansLocale
    );
    return isNewClientLocale || isNewTechniciansLocale || isNewCenter;
  }

  getMyPosition = async () => {
    try {
      const { latitude, longitude } = await getCurrentPosition();
      this.setState({
        center: {
          lat: latitude,
          lng: longitude,
        },
      });
    } catch (err) {}
  };

  renderTechnicians = () =>
    this.props.techniciansLocale.map(({ lat, lng }, index) => (
      <Technician lat={lat} lng={lng} key={index} />
    ));

  renderMyLocation = () => (
    <ProductMarker
      lat={this.props.clientLocale.lat}
      lng={this.props.clientLocale.lng}
    />
  );

  render() {
    const { zoom, apiKey, techniciansLocale } = this.props;
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          center={centerMyMap(techniciansLocale) || this.state.center}
          defaultZoom={zoom}
        >
          {this.renderTechnicians()}
          {this.props.clientLocale && this.renderMyLocation()}
        </GoogleMapReact>
      </div>
    );
  }
}

TechnicianMap.propTypes = {
  techniciansLocale: array,
  clientLocale: shape({
    lat: number,
    lng: number,
  }),
  zoom: number,
};

TechnicianMap.defaultProps = {
  techniciansLocale: [],
  zoom: 15,
};

export default TechnicianMap;



// WEBPACK FOOTER //
// ./src/components/TechnicianModal/components/TechnicianMap/index.js